import React from 'react'
import { TextInput } from 'SRC/ui/FormElements'
import useTranslation from 'next-translate/useTranslation'

export const Surname = () => {
  const { t } = useTranslation('common')

  return (
    <TextInput id='surname' name='surname' label={t('Prezime')} allowedCharacters={['letters']} />
  )
}
